import { render, staticRenderFns } from "./location-list-item.component.vue?vue&type=template&id=22bf05b4"
import script from "./location-list-item.component.ts?vue&type=script&lang=ts&external"
export * from "./location-list-item.component.ts?vue&type=script&lang=ts&external"
import style0 from "./location-list-item.component.vue?vue&type=style&index=0&id=22bf05b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports